import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "../../../../common/config";
import { FaRegFileAlt } from "react-icons/fa";
import {
  configureDocTitle,
  configureDocDescription,
  docOptions
} from "../../../../data/DataFile";
import HeaderNew from "../../../../common/components/custom/header-new/HeaderNew";
import "./DocumentType.scss";

const DocumentType = () => {
  const navigate = useNavigate();

  const renderIcon = useCallback((type: string) => {
    switch (type) {
      case "upload":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14,2 14,8 20,8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10,9 9,9 8,9" />
          </svg>
        );
      case "plus":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14,2 14,8 20,8" />
            <line x1="12" y1="11" x2="12" y2="17" />
            <line x1="9" y1="14" x2="15" y2="14" />
          </svg>
        );
      case "tag":
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
            <line x1="7" y1="7" x2="7.01" y2="7" />
          </svg>
        );
      default:
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14,2 14,8 20,8" />
          </svg>
        );
    }
  }, []);

  const handleOptionClick = useCallback(
    (option: any) => {
      if (option.title === "Flow Configuration") {
        navigate(MainRoutes.ASSIGNMENT);
      } else if (option.title === "Extraction Configuration") {
        navigate(MainRoutes.EXTRACTION_CONFIGURATION);
      } else if (option.title === "Tag Library Configuration") {
        navigate(MainRoutes.TAG_LIBRARY_CONFIG);
      } else {
        navigate(MainRoutes.ASSIGNMENT);
      }
    },
    [navigate]
  );

  return (
    <div>
      <HeaderNew showSearch={false} />
      <div className="configure-hub">
        {/* Title Section */}
        <div className="title-section">
          <h1 className="title">{configureDocTitle}</h1>
          <div className="title-indicators">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
        </div>
        <p className="description">{configureDocDescription}</p>

        {/* Document Type Options */}
        <div className="options-grid">
          {docOptions.map((option, index) => (
            <div
              key={index}
              // className={`option-card ${option.route ? "clickable" : ""}`}
              className="option-card"
              onClick={() => handleOptionClick(option)}
            >
              <div className="card-content">
                <div className="card-text">
                  <div className="card-title">{option.title}</div>
                  <div className="card-description">{option.description}</div>
                </div>
                <div className="icon">{renderIcon(option.iconType)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocumentType;
